import React from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import * as actions from "../../actions/actions";
import { KITS_FLOW } from "../../reducers/kits";

const IconBasicSaveForLater = ({
    kitsFetch,
    icon,
    iconSaved,
    initialized,
    loggedIn,

    downloadShowAuth,
    kitsSaveToFavorites,
    kitsRemoveFromFavorites
}) => {
    React.useEffect(() => {
        if (!initialized && loggedIn) {
            kitsFetch();
        }
    }, [initialized, loggedIn, kitsFetch]);

    let onButtonClick;
    let buttonTitle = loggedIn ? "Save this icon in your Favorites kit" : "";
    if (loggedIn) {
        if (iconSaved) {
            onButtonClick = kitsRemoveFromFavorites.bind(null, icon.id);
            buttonTitle = "Remove this icon from your Favorites kit";
        } else {
            onButtonClick = kitsSaveToFavorites.bind(null, icon.id, null);
        }
    } else {
        onButtonClick = downloadShowAuth.bind(null, KITS_FLOW, {
            iconId: icon.id
        });
    }

    let buttonClass = classnames("icon-save-for-later button", {
        black: iconSaved
    });
    let buttonText = iconSaved ? "Saved to Favorites" : "Save to Favorites";

    return (
        <div
            data-test-id="kits-save-for-later"
            className={buttonClass}
            onClick={onButtonClick}
            title={buttonTitle}
        >
            {buttonText}
        </div>
    );
};

const mapStateToProps = (state, ownProps) => {
    let { kits, user } = state;
    let { savedIconIds, dropdownShowing } = kits;
    let iconSaved = !!savedIconIds[Number(ownProps.icon.id)];
    let initialized = Object.keys(kits.all).length;
    let loggedIn = !user || !user.is_anonymous;

    return {
        iconSaved,
        initialized,
        loggedIn,
        dropdownShowing
    };
};

export default connect(mapStateToProps, {
    kitsFetch: actions.kitsFetch,
    downloadShowAuth: actions.downloadShowAuth,
    kitsSaveToFavorites: actions.kitsSaveToFavorites,
    kitsRemoveFromFavorites: actions.kitsRemoveFromFavorites
})(IconBasicSaveForLater);
